module.exports = __webpack_public_path__ + "static/media/userPicture.2457354a.svg";